import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { GoBackLink } from '../GoBackLink'
import { Table } from 'react-bootstrap'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { LoadingSpinner } from '@CommonComponents'
import { toast } from '@CommonComponents/toast'
import { NewCourseModal } from '../modals/NewCourseModal'
import { RemoveConfirmModal } from '../modals/RemoveConfirmModal'
import { HealthCheckTable } from './HealthCheckTable'
import { ChangeCourseModal } from '../modals/ChangeCourseModal'
import { GradeLogListView } from '../grade_logs/GradeLogListView'
import { EditContextModal } from '../modals/EditContextModal'
import { SetupContextConfirmModal } from '../modals/SetupContextConfirmModal'

export const Context = ({ match }) => {
  const [currentState, dispatch] = useStateValue()
  const [newCourseModalOpen, toggleModal] = useState(false)
  const [setupContextConfirmModalOpen, toggleContextModal] = useState(false)

  const [editInstanceModalOpen, setEditInstanceModalOpen] = useState(false)

  const [removeModalOpen, toggleRemoveModal] = useState(false)
  const [removeModalURL, setRemoveModalURL] = useState('')
  const [removeModalMessage, setRemoveModalMessage] = useState('')
  const [removeModalTitle, setRemoveModalTitle] = useState('')
  const [getMembersError, setGetMembersError] = useState('')
  const [healthCheckData, setHealthCheckData] = useState('')
  const [healthCheckDataLoading, setHealthCheckDataLoading] = useState(false)
  const [healthCheckError, setHealthCheckError] = useState('')
  const [changeCourseModalOpen, toggleChangeCourseModal] = useState(false)
  const [changeCourseModalCoursenum, setChangeCouresModalCoursenum] =
    useState('')
  const [contextLoading, setContextLoading] = useState(true)

  useEffect(() => {
    const getMembers = async () => {
      try {
        let membersResp = await client.get(
          `/account/admin_lti13.getContextMembers/-/${match.params.contextId}/`
        )
        dispatch({
          type: 'updateMembers',
          members: membersResp.data.members,
        })
      } catch (err) {
        if (err.response) {
          setGetMembersError(err.response.data.error)
          toast.error(`${err.response.statusText} ${err.response.data.error}`)
        } else {
          setGetMembersError(err)
        }
      }
    }
    getMembers()
  }, [currentState.reloadSwitch])

  useEffect(() => {
    const getCourses = async () => {
      setContextLoading(true)
      try {
        let contextCoursesResp = await client.get(
          // `/account/admin_lti13.getContextCourses/-/${match.params.contextId}/`
          `/account/admin_lti13.getContextCourses/-/${match.params.issuerId}/${match.params.clientId}/${match.params.deploymentId}/${match.params.contextId}/`
        )
        dispatch({
          type: 'updateCourseTable',
          courseTableData: contextCoursesResp.data.contextCourses,
        })
        dispatch({
          type: 'updateContext',
          context: contextCoursesResp.data.context,
        })
      } catch (err) {
        if (err.response) {
          dispatch({ type: 'updateMessage', message: err.response.statusText })
          toast.error(`${err.response.statusText} ${err.response.data.error}`)
        } else {
          dispatch({ type: 'updateMessage', message: err })
        }
      } finally {
        setContextLoading(false)
      }
    }
    getCourses()
  }, [currentState.reloadSwitch])

  const openDeleteContextCourseModal = contextCourseObject => {
    setRemoveModalTitle('Remove Context Course')
    setRemoveModalURL(
      `/account/admin_lti13.deleteContextCourse/-/${contextCourseObject.id}/`
    )
    setRemoveModalMessage(
      `Are you sure you want to remove ${contextCourseObject.course.title} (${contextCourseObject.course.coursenum})?`
    )
    toggleRemoveModal(true)
  }
  const openDeleteMembersModal = context => {
    setRemoveModalTitle('Remove Context Members')
    setRemoveModalURL(
      `/account/admin_lti13.deleteContextMembers/${context.id}/`
    )
    setRemoveModalMessage(
      `Are you sure you want to delete all members for ${context.contextTitle}?`
    )
    toggleRemoveModal(true)
  }

  const fetchHealthData = async () => {
    setHealthCheckDataLoading(true)
    try {
      let healthData = await client.get(
        `/account/admin_lti13.contextHealthCheck/-/${match.params.contextId}`
      )
      const sanitizedData = healthData.data

      setHealthCheckData(sanitizedData)
      setHealthCheckDataLoading(false)
    } catch (err) {
      setHealthCheckError('Error error error')
    }
  }
  const openChangeCourseModal = contextCoursenum => {
    setChangeCouresModalCoursenum(contextCoursenum)
    toggleChangeCourseModal(true)
  }

  return (
    <>
      <div className="mb-4">
        {currentState.canEdit && (
          <div className="pi-info pull-right">
            <button
              onClick={() => setEditInstanceModalOpen(true)}
              className="btn btn-sm btn-sm-myed btn-primary"
            >
              Edit <i className="fa-regular fa-edit" />
            </button>
          </div>
        )}
        {currentState.canEdit && (
          <div className="pull-right add-new-course-right-align">
            <div
              className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
              onClick={() => toggleModal(!newCourseModalOpen)}
            >
              <div className="fa-regular fa-plus fa-fw mr-2" /> Add New Course
            </div>
          </div>
        )}
        <div className="go-back-button-left-align">
          <GoBackLink to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers/${match.params.issuerId}/clients/${match.params.clientId}/deployments/${match.params.deploymentId}`} />
        </div>
      </div>
      {contextLoading && !currentState.context && (
        <div className="card-myed">
          <LoadingSpinner text="Loading context..." outerClass="text-center my-4" />
        </div>
      )}
      {currentState.context && (
        <div className="card-myed">
          <h3>Context </h3>
          <div>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Context Id:
              </span>{' '}
              {currentState.context.contextId}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Id:
              </span>{' '}
              {currentState.context.id}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Context Title:
              </span>{' '}
              {currentState.context.contextTitle}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Context Label:
              </span>{' '}
              {currentState.context.contextLabel}
            </p>
            {currentState.context.lmsCourseId && (
              <p>
                <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                  Canvas Course Number:
                </span>{' '}
                {currentState.context.lmsCourseId}
              </p>
            )}
            <div className="flex flex-row my-2">
              <p>
                <Link
                  style={{ fontSize: '1.2em', fontWeight: 'bolder' }}
                  to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers/${match.params.issuerId}/clients/${match.params.clientId}/deployments/${match.params.deploymentId}/contexts/${match.params.contextId}/Members`}
                >
                  Members:
                </Link>{' '}
                {getMembersError ? (
                  <span style={{ color: 'rgb(184, 54, 52)' }}>
                    <i
                      className={`far fa-fw mr-4 color_red icon_color_red fa-exclamation-triangle`}
                    />
                    {getMembersError}
                  </span>
                ) : (
                  currentState.members.length
                )}
              </p>
              {currentState.members.length > 0 && (
                <a
                  onClick={() => openDeleteMembersModal(currentState.context)}
                  style={{ marginLeft: '1em' }}
                  className="btn btn-sm btn-sm-myed btn-danger"
                >
                  Remove <i className="fa-regular fa-window-close" />
                </a>
              )}
            </div>
            <div className="text-right">
              <button
                title="Context cannot be connected to any courses and there must be a parent context ID to use this feature."
                disabled={
                  !currentState.context.parentContextId ||
                  currentState.courseTableData.length > 0
                }
                onClick={() =>
                  toggleContextModal(!setupContextConfirmModalOpen)
                }
                className="btn btn-sm btn-sm-myed btn-primary"
              >
                Create Course from History
              </button>
            </div>
          </div>
          <h3>Context Courses:</h3>
          <div className="table-responsive">
          <Table striped bordered className="table-sm" hover>
            <thead>
              <tr>
                <th>Course</th>
                <th>Coursenum</th>
                <th>Details</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentState.courseTableData.map((contextCourse, i) => (
                <tr key={i}>
                  <td>{contextCourse.context.contextTitle}</td>
                  <td>{contextCourse.course.coursenum}</td>
                  <td>
                    <Link
                      to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers/${match.params.issuerId}/clients/${match.params.clientId}/deployments/${match.params.deploymentId}/contexts/${match.params.contextId}/contextCourses/${contextCourse.id}`}
                    >
                      View Course Links
                      {!currentState.context.lineitems && (
                        <i
                          className={`far fa-fw mr-4 color_red icon_color_red fa-exclamation-triangle`}
                        />
                      )}
                    </Link>
                  </td>
                  <td>
                    <a
                      onClick={() =>
                        openDeleteContextCourseModal(contextCourse)
                      }
                      className="btn btn-sm btn-sm-myed btn-danger"
                    >
                      Remove <i className="fa-regular fa-window-close" />
                    </a>
                    <a
                      onClick={() =>
                        openChangeCourseModal(contextCourse.course.coursenum)
                      }
                      className="btn btn-sm btn-sm-myed btn-warning ml-2"
                    >
                      Change Course <i className="fa-regular fa-edit" />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          </div>
          <NewCourseModal
            contextPk={match.params.contextId}
            show={newCourseModalOpen}
            toggle={toggleModal}
          />
          <RemoveConfirmModal
            modalTitle={removeModalTitle}
            message={removeModalMessage}
            endpoint={removeModalURL}
            show={removeModalOpen}
            toggle={toggleRemoveModal}
            currentState={currentState}
            dispatch={dispatch}
          />
          <ChangeCourseModal
            ctxId={currentState.context.id}
            ctxCoursenum={changeCourseModalCoursenum}
            show={changeCourseModalOpen}
            toggle={toggleChangeCourseModal}
            currentState={currentState}
            dispatch={dispatch}
          />
          <SetupContextConfirmModal
            contextPk={match.params.contextId}
            show={setupContextConfirmModalOpen}
            toggle={toggleContextModal}
          />
        </div>
      )}
      <div className="health-check-button-align">
        <button
          className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
          disabled={healthCheckDataLoading}
          onClick={() => fetchHealthData()}
        >
          <div className="fa-regular fa-heartbeat mr-2" />{' '}
          {healthCheckDataLoading ? 'Analyzing...' : 'Start Health Check'}
        </button>
      </div>
      {healthCheckError && (
        <div className="mt-3 text-danger">{healthCheckError}</div>
      )}
      {healthCheckData && (
        <HealthCheckTable
          data={healthCheckData}
          context={match.params.contextId}
        />
      )}
      <GradeLogListView queryParams={{ context_id: match.params.contextId }} />
      <EditContextModal
        show={editInstanceModalOpen}
        toggle={setEditInstanceModalOpen}
        context={currentState.context}
        issuerid={match.params.issuerId}
        clientid={match.params.clientId}
        deploymentid={match.params.deploymentId}
        contextid={match.params.contextId}
      />
    </>
  )
}
